import * as React from "react";
import {EDPageLoader} from "@trailblazer-game/ed-webkit";
import dynamic from "next/dynamic";
import PageLayout from "../components/Shared/PageLayout";

const Download = dynamic(() => import("../components/Pages/DownloadApp/Public/DownloadApp"), {
  suspense: false,
  ssr: false,
  loading: () => <EDPageLoader in={true}/>,
})

export default function DownloadPage() {
  return <PageLayout backgroundImage={"/downloadApp/bg.webp"}
                     justifyContent={"flex-start"}>
    <Download/>
  </PageLayout>
}

DownloadPage.metaData = {
  title: 'Eternal Dragons - Download the Ultimate Auto-Battler Game',
  image: "https://cdn.eternaldragons.com/assets/download_og_image.png",
  description: "Join the epic battle of dragons and minions! Download Eternal Dragons now to command legendary creatures, conquer foes, and rule the battlefield. Available on Android and iOS."
}